import { render, staticRenderFns } from "./Defects.vue?vue&type=template&id=19d8b976&scoped=true&"
import script from "./Defects.vue?vue&type=script&lang=js&"
export * from "./Defects.vue?vue&type=script&lang=js&"
import style0 from "./Defects.vue?vue&type=style&index=0&id=19d8b976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8b976",
  null
  
)

export default component.exports